import { useAuthDataContext } from '../components/AuthDataProvider';


export default function LogoutPage() {
    const { onLogout } = useAuthDataContext();

    onLogout();

    return (<h3>You are logged out</h3>)
}
